// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run pnpm gen:gql to update it
/* eslint-disable */

import type * as Types from '../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateMyDefaultCurrencyMutationVariables = Types.Exact<{
  currency: Types.Scalars['String']['input'];
}>;


export type UpdateMyDefaultCurrencyMutation = { __typename?: 'Mutation', featuresToggleCurrency?: { __typename?: 'FeaturesToggleCurrencyPayload', isTagEnabled?: boolean, features?: { __typename?: 'Features', id: string, walletCurrency?: string }, errors?: Array<{ __typename?: 'FeaturesError', message?: string, code?: number, params?: Array<{ __typename?: 'FeaturesErrorParam', name?: string, value?: string }> }> } };


export const UpdateMyDefaultCurrencyMutationDocument = /*#__PURE__*/ gql`
    mutation UpdateMyDefaultCurrencyMutation($currency: String!) {
  featuresToggleCurrency(input: {currency: $currency}) {
    isTagEnabled
    features {
      id
      walletCurrency: myGroupTag(name: "DepositCurrency")
    }
    errors {
      message
      code
      params {
        name
        value
      }
    }
  }
}
    `;
export type UpdateMyDefaultCurrencyMutationMutationFn = Apollo.MutationFunction<UpdateMyDefaultCurrencyMutation, UpdateMyDefaultCurrencyMutationVariables>;
export function useUpdateMyDefaultCurrencyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyDefaultCurrencyMutation, UpdateMyDefaultCurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyDefaultCurrencyMutation, UpdateMyDefaultCurrencyMutationVariables>(UpdateMyDefaultCurrencyMutationDocument, options);
      }
export type UpdateMyDefaultCurrencyMutationHookResult = ReturnType<typeof useUpdateMyDefaultCurrencyMutation>;
export type UpdateMyDefaultCurrencyMutationMutationResult = Apollo.MutationResult<UpdateMyDefaultCurrencyMutation>;
export type UpdateMyDefaultCurrencyMutationMutationOptions = Apollo.BaseMutationOptions<UpdateMyDefaultCurrencyMutation, UpdateMyDefaultCurrencyMutationVariables>;